// extracted by mini-css-extract-plugin
module.exports = {"gridForm":"ColumnMapping_gridForm__171Dx","required":"ColumnMapping_required__38xnF"};